import config from '../config'
import { SET_CONFIG, SET_CONTENU } from "./actionTypes";

const initialState = config;

export default function appReducer(state = initialState, action=null) {
  switch (action.type) {

    case SET_CONFIG: {
      return {
        ...state,
        ...action.payload,
      };

    }
    case SET_CONTENU: {
      return {
        ...state,
        contenu: action.payload,
      };

    }
    default:
      return state;
  }
}
